import { signal } from "@preact/signals-react"
import { ChannelType } from "../types/channel"

export const currentChannel = signal<ChannelType | null>(null)
